// extracted by mini-css-extract-plugin
export default {"icon":"C9qAjZ6NAjpjoFm2c1WB","placeHolderShimmer":"I_8GX21mymFmorrfdfJ5"};